// Used in leerlingen component within modules wisaapp-afwezigheden EN wisaapp-webstudent
import LSL from '@/mixins/local-storage-layer.js'
import * as globalMutationTypes from '@/store/mutation-types.js'
export default {
  data() {
    return {
      leerlingListRSM: {
        toonFotos: false,
        toonDetails: false,
        Afgelaste: false,
        toonFilter: false,
        fullscreen: false,
        sortToNaam: true,
        sortToVoornaam: false,
        sortToKlasNummer: false,
        groupToKlas: true,
      },
      leerlingListRSMName: this.$store.state.activeModule + 'leerlingListRSM'
    }
  },
  created() {
    console.log('Leerling sort RSM created')
    console.log(this.leerlingListRSMName, this.leerlingListRSM)
    LSL.methods.initializeLSForAFeatureIfNeeded(this.leerlingListRSMName, this.leerlingListRSM)
  },
  mounted() {
    console.log('Leerling sort RSM mounted')
    this.decryptState()
    this.updateRightSideMenuItems()
  },
  destroyed() {
    this.encryptState()
  },
  methods: {
    decryptState() {
      this.leerlingListRSM = LSL.methods.getLSProp(this.leerlingListRSMName)
      console.log('decyrpting...')
    },
    encryptState() {
      LSL.methods.setLSProp(this.leerlingListRSMName, this.leerlingListRSM)
      console.log('encyrpting...')
    },
    toggleSortToNaam() {
      if (!this.leerlingListRSM.sortToNaam) {
        this.leerlingListRSM.sortToNaam = true
        this.leerlingListRSM.sortToVoornaam = false
        this.leerlingListRSM.sortToKlasNummer = false
      }
      this.updateRightSideMenuItems()
    },
    toggleSortToVoornaam() {
      if (!this.leerlingListRSM.sortToVoornaam) {
        this.leerlingListRSM.sortToVoornaam = true
        this.leerlingListRSM.sortToNaam = false
        this.leerlingListRSM.sortToKlasNummer = false
      }
      this.updateRightSideMenuItems()
    },
    toggleSortToKlasNummer() {
      if (!this.leerlingListRSM.sortToKlasNummer) {
        this.leerlingListRSM.sortToKlasNummer = true
        this.leerlingListRSM.sortToNaam = false
      }
      this.updateRightSideMenuItems()
    },
    toggleGroupToKlas() {
      this.leerlingListRSM.groupToKlas = !this.leerlingListRSM.groupToKlas
      this.updateRightSideMenuItems()
    },
    toggleToonFotos() {
      this.leerlingListRSM.toonFotos = !this.leerlingListRSM.toonFotos
      this.updateRightSideMenuItems()
    },
    toggleToonDetails() {
      this.leerlingListRSM.toonDetails = !this.leerlingListRSM.toonDetails
      this.updateRightSideMenuItems()
    },
    toggleAfgelasteKlassen() {
      this.leerlingListRSM.Afgelaste = !this.leerlingListRSM.Afgelaste
      this.updateRightSideMenuItems()
    },
    toggleToonFilters() {
      this.leerlingListRSM.toonFilter = !this.leerlingListRSM.toonFilter
      this.updateRightSideMenuItems()
    },
    toggleFullscreen() {
      // this.leerlingListRSM.fullscreen = !this.leerlingListRSM.fullscreen
      this.toggleFullScreenEvent()
      this.updateRightSideMenuItems()
    },
    toggleFullScreenEvent() {
      var doc = window.document;
      var docEl = doc.documentElement;

      var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
      var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

      if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
        requestFullScreen.call(docEl);
      }
      else {
        cancelFullScreen.call(doc);
      }
    },
    updateRightSideMenuItems() {

      let rsm = []
      if (this.$store.state.wstudent.currentScreen === 'Agenda') {
        rsm.push({
          text: 'Toon filter',
          icon: this.icons.FILTER,
          selected: this.leerlingListRSM.toonFilter,
          FUNCTIE: this.toggleToonFilters
        })
        rsm.push({
          text: 'Toon details',
          icon: this.icons.DETAILS,
          selected: this.leerlingListRSM.toonDetails,
          FUNCTIE: this.toggleToonDetails
        })
        rsm.push({
          text: 'Afgelaste klassen',
          icon: this.icons.DETAILS,
          selected: this.leerlingListRSM.Afgelaste,
          FUNCTIE: this.toggleAfgelasteKlassen
        })
        rsm.push({
          text: 'Volledig scherm',
          icon: this.icons.FULLSCREEN,
          selected: this.leerlingListRSM.fullscreen,
          FUNCTIE: this.toggleFullscreen,

        })
      }
      if (this.$store.state.wstudent.currentScreen === 'login') {

        rsm.push({
          text: 'Volledig scherm',
          icon: this.icons.FULLSCREEN,
          selected: this.leerlingListRSM.fullscreen,
          FUNCTIE: this.toggleFullscreen

        })


      }

      if (this.$store.state.wstudent.currentScreen === 'configuratie') {


        rsm.push({
          text: 'Volledig scherm',
          icon: this.icons.FULLSCREEN,
          selected: this.leerlingListRSM.fullscreen,
          FUNCTIE: this.toggleFullscreen

        })

        // rsm.push({ separator: true })


      }
      this.$store.commit(globalMutationTypes.SET_MENUBAR_RIGHT_SIDE_MENU_ITEMS, rsm)
    }
  }
}
